import React from 'react'

const TimeframeFilter = ({ selected, onChange }) => {
  const timeframes = [
    { value: 'all_future', label: 'All Future' },
    { value: 'today', label: 'Today' },
    { value: 'tomorrow', label: 'Tomorrow' },
    { value: 'this_week', label: 'This Week' },
    { value: 'next_week', label: 'Next Week' },
    { value: 'this_month', label: 'This Month' },
    { value: 'next_month', label: 'Next Month' }
  ]

  return (
    <div>
      <h3 className="text-sm sm:text-base font-medium text-gray-700 dark:text-gray-300 mb-3">
        When
      </h3>
      
      {/* Mobile dropdown - visible on mobile only */}
      <div className="sm:hidden relative">
        <select
          value={selected}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-4 py-2 pr-10 rounded-lg bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-0 focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 appearance-none cursor-pointer"
        >
          {timeframes.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        {/* Custom dropdown arrow */}
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
          <svg className="h-5 w-5 text-gray-600 dark:text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6 8l4 4 4-4"/>
          </svg>
        </div>
      </div>
      
      {/* Desktop/tablet buttons - hidden on mobile */}
      <div className="hidden sm:flex sm:flex-wrap gap-3">
        {timeframes.map(({ value, label }) => (
          <button
            key={value}
            onClick={() => onChange(value)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
              selected === value
                ? 'bg-blue-600 text-white hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default TimeframeFilter